function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Knet = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgKnet = function SvgKnet(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("rect", {
      width: 60,
      height: 40,
      fill: "#0872B9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M45.9186 9.32203H44.6725V10.0949H45.9186V9.32203Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M44.3255 9.32203H43.0793V10.0949H44.3255V9.32203Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M25.6098 7.86295H24.8448V6.77456H23.3069V7.86295H12.1942L12.0601 7.57902L13.1091 6.2067V5.22083H11.5948L9.93066 7.39762L10.8771 9.43244H27.1478V6.77456H25.6098V7.86295Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M27.0374 5.33914H25.7912V6.11206H27.0374V5.33914Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.3332 5.57574H14.0871V6.34866H15.3332V5.57574Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.95 5.57574H15.7039V6.34866H16.95V5.57574Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M49.5072 6.45908H44.9643L44.2703 5.87545H49.0971L48.6002 5H42.5352L42.4326 5.30759L44.5148 7.0506H48.1033V7.50804H44.2308L42.9137 6.41176H40.2874V8.73051H35.9654V7.78408H39.6091V6.41176H33.7176V9.85834H41.849V8.02857L42.7639 8.7936H49.5703L50.5246 7.81563V7.49226L49.5072 6.45908Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M31.5487 7.19256H28.67V8.44658H31.5487V7.19256Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M45.7924 24.0784L38.0081 18.2263L45.6505 13.5415H31.9588L25.2549 17.6427V13.5415H15.7039V24.0784H25.2549V18.597L31.391 24.0784H45.7924Z",
      fill: "#FFF200"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.8031 33.4875V28.2664H15.1755V28.8894C15.3726 28.6371 15.6013 28.4478 15.8695 28.3216C16.1377 28.1954 16.4295 28.1323 16.7607 28.1323C17.3365 28.1323 17.7702 28.2822 18.0542 28.5819C18.3381 28.8816 18.488 29.3311 18.488 29.9305V33.4875H17.092V30.3328C17.092 29.9542 17.0289 29.6939 16.9027 29.5283C16.7765 29.3706 16.5714 29.2917 16.2875 29.2917C15.9563 29.2917 15.696 29.3863 15.5067 29.5835C15.3174 29.7807 15.2149 30.0488 15.2149 30.388V33.4875H13.8031V33.4875Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M31.0834 31.8392H32.4793C32.3374 32.3912 32.0534 32.825 31.6275 33.1326C31.2017 33.4481 30.6811 33.5979 30.0659 33.5979C29.3088 33.5979 28.7094 33.3456 28.2677 32.8329C27.8261 32.3281 27.6052 31.6341 27.6052 30.7665C27.6052 29.9147 27.8261 29.2365 28.2598 28.7475C28.6936 28.2506 29.293 28.0061 30.0502 28.0061C30.8467 28.0061 31.4698 28.2506 31.9036 28.7317C32.3374 29.2207 32.5582 29.9069 32.5582 30.806C32.5582 30.9085 32.5582 30.9795 32.5582 31.0268C32.5582 31.0741 32.5503 31.1214 32.5424 31.1688H29.0564C29.0722 31.5789 29.1747 31.8865 29.3561 32.0994C29.5375 32.3045 29.7978 32.4149 30.1369 32.4149C30.3735 32.4149 30.5707 32.3676 30.7284 32.2729C30.8704 32.1862 30.9966 32.0363 31.0834 31.8392ZM29.0485 30.2618H31.107C31.0912 29.9069 30.9966 29.6387 30.8231 29.4573C30.6496 29.2759 30.3972 29.1813 30.0738 29.1813C29.7662 29.1813 29.5296 29.2759 29.3561 29.4573C29.1747 29.6466 29.0722 29.9147 29.0485 30.2618Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M46.4234 34.1342C46.2972 34.1342 46.1395 34.1421 45.966 34.15C45.7846 34.1579 45.6741 34.1658 45.6268 34.1658C45.0905 34.1658 44.7277 34.0633 44.5305 33.8661C44.3334 33.6689 44.2387 33.2746 44.2387 32.6831V29.8595H43.5447V28.8816H44.2387V27.454H45.6189V28.8816H46.4234V29.8595H45.6189V32.754C45.6189 32.8881 45.6505 32.9828 45.7136 33.0222C45.7767 33.0616 45.9029 33.0853 46.0921 33.0853H46.4313V34.1342H46.4234Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M51.4 11.3411H9V12.1613H51.4V11.3411Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M51.4 25.3877H9V26.2079H51.4V25.3877Z",
      fill: "white"
    })));
  };

  var _default = SvgKnet;
  _exports["default"] = _default;
});